import PermissionType from "@/models/Settings/Roles/PermissionType";
import { AuthModule } from '@/store/Auth/AuthModule';
import BankingIntegrations from '@/models/Settings/Institutions/Integrations/BankingIntegrations';
import CardIntegrations from "@/models/Settings/Institutions/Integrations/CardIntegrations";

export default class PermissionUtils {
    static hasPermission(permissionType: PermissionType) {
        if (permissionType === PermissionType.PortalRead) {
            return true;
        }
        if (AuthModule.me) {
            if (AuthModule.me.globalAdmin) {
                return true;
            }
            if (AuthModule.me.permissions !== null) {
                return AuthModule.me.permissions.includes(permissionType);
            }
        }
    }

    static isFeatureToggleEnabled(featureToggleCode: string) {
        // Checks the list of feature toggles on an institution to find the feature with a given code,
        // then returns whether or not this feature is enabled
        const featureToggle = AuthModule.me.institution.config.featureToggles.find((toggle) => toggle.code === featureToggleCode);
        if (featureToggle) {
            return featureToggle.enabled;
        }
        else {
            return false;
        }
    }

    static hasSwisscomBankingIntegration() {
        // Checks the list of banking integrations on the current institution and
        // returns whether or not it includes an integration for Swisscom
        const bankingIntegrations = AuthModule.me.institution.config.bankingIntegrations;
        return bankingIntegrations.includes(BankingIntegrations.Swisscom);
    }

    static hasGpsCardIntegration() {
        // Checks the list of banking integrations on the current institution and
        // returns whether or not it includes an integration for Swisscom
        const cardIntegrations = AuthModule.me.institution.config.cardIntegrations;
        return cardIntegrations.includes(CardIntegrations.GPS);
    }

    static allowUxApiAccess() {
        // Use this to override the access for the UX API, usually the setting comes from the platform however
        // this setting can be used to ignore the backend and override the behaviour
        const isUxApiAccessDisabled: boolean = localStorage.getItem("saascada-disable-ux-api-access") ? true : false;
        if (!isUxApiAccessDisabled) {
            return true;
        }
        else {
            return false;
        }
    }

    static isDevEnvironment() {
        // Use this ONLY to control the showing of features in the dev environment such as the UX API override toggle
        if (process.env.NODE_ENV === 'development') {
            return true;
        }
        else {
            return false;
        }
    }

    static getPageSize() {
        // Not really a permission related utility but best to put this here alongside other portal settings
        // Get the number of rows setting and default to 10 if nothing is found
        const rowsSetting = localStorage.getItem("saascada-number-of-rows");
        if (rowsSetting) {
            return parseInt(localStorage.getItem("saascada-number-of-rows"));
        }
        else {
            return 10;
        }
    }
}